<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">品番検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_SKU_SEARCH>{{
          $t("app.buttons.search")
        }}</v-btn>
        <v-btn @click="create" v-permit.SHARP_SKU_NEW>{{
          $t("app.buttons.new")
        }}</v-btn>
        <v-btn
          :disabled="selected.length != 1"
          @click="edit"
          v-permit.SHARP_SKU_EDIT.SHARP_SKU_DETAIL
          >{{ $t("app.buttons.edit") }}</v-btn
        >
        <v-btn
          :disabled="selected.length == 0"
          @click="remove"
          v-permit.SHARP_SKU_DELETE
          >{{ $t("app.buttons.remove") }}</v-btn
        >
        <table-upload @input="skuMatchProduct" title="品種アップ" />
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
        <v-btn v-permit.SHARP_SKU_DOWNLOAD @click="download()"
          >検索結果出力</v-btn
        >
        <a @click="$downloadTemplate('M0160', 'excel')" href="#"
          >Excel template</a
        >
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.skuCode')"
                clearable
                v-model="query.code"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="品番（海外)CD"
                v-model="query.supplierCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="部品名称１" v-model="query.name" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="部品名称２"
                v-model="query.name2"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kv?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.productCode')"
                item-text="name"
                item-value="code"
                url="products/codes"
                v-model="query.productCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="部品区分名" v-model="query.type" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="N/W重量単位"
                v-model="query.netWeightUnit"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="1個当りのN/W"
                v-model="query.unitNetWeight"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="箱重量単位"
                v-model="query.boxWeightUnit"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="箱の重さ"
                v-model="query.boxWeight"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="入り数" v-model="query.boxQty" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="箱サイズ縦"
                v-model="query.boxWidth"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="箱サイズ横"
                v-model="query.boxLength"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="箱サイズ高さ"
                v-model="query.boxHeight"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="容積単位"
                v-model="query.boxVolumeUnit"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="箱容積"
                v-model="query.boxVolume"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.createDateTo"
                    label="作成日付"
                    v-model="query.createDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.createDateFrom"
                    label
                    v-model="query.createDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.supplierCode }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.name2 }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.productCode }}</td>
          <td>{{ props.item.productName }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.netWeightUnit }}</td>
          <td>{{ props.item.unitNetWeight }}</td>
          <td>{{ props.item.boxWeightUnit }}</td>
          <td>{{ props.item.boxWeight }}</td>
          <td>{{ props.item.boxQty }}</td>
          <td>{{ props.item.boxWidth }}</td>
          <td>{{ props.item.boxLength }}</td>
          <td>{{ props.item.boxHeight }}</td>
          <td>{{ props.item.boxVolumeUnit }}</td>
          <td>{{ props.item.boxVolume }}</td>
          <td>{{ props.item.createDate }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      dateRules: [
        (v) =>
          (!!v && this.validDate()) ||
          "最大31日以内のデータを一括出力可能であるため、作成日付を選び直してください。",
      ],
      headers: [
        { text: "品番CD", value: "code", sortable: false },
        { text: "品番（海外)CD", value: "supplierCode", sortable: false },
        { text: "部品名称１", value: "name", sortable: false },
        { text: "部品名称２", value: "name2", sortable: false },
        { text: "海外取引先", value: "supplier.name", sortable: false },
        { text: "品種CD", value: "product.code", sortable: false },
        { text: "品種名", value: "product.name", sortable: false },
        { text: "部品区分名", value: "type", sortable: false },
        { text: "N/W重量単位", value: "netWeightUnit", sortable: false },
        { text: "1個当りのN/W", value: "unitNetWeight", sortable: false },
        { text: "箱重量単位", value: "boxWeightUnit", sortable: false },
        { text: "箱の重さ", value: "boxWeight", sortable: false },
        { text: "入り数", value: "boxQty", sortable: false },
        { text: "箱サイズ縦", value: "boxWidth", sortable: false },
        { text: "箱サイズ横", value: "boxLength", sortable: false },
        { text: "箱サイズ高さ", value: "boxHeight", sortable: false },
        { text: "容積単位", value: "boxVolumeUnit", sortable: false },
        { text: "箱容積", value: "boxVolume", sortable: false },
        { text: "作成日付", value: "createDate", sortable: false },
      ],
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
    };
  },
  methods: {
    download() {
      if (!this.query.createDateFrom || !this.query.createDateTo) {
        this.$message("", "作成日付を入力して検索してください。");
        return;
      }
      if (
        this.$daysBetween(this.query.createDateFrom, this.query.createDateTo) >
        31
      ) {
        this.$message(
          "",
          "最大31日以内のデータを一括出力可能であるため、作成日付を選び直してください。"
        );
        return;
      }
      var headers = [
        "品番CD",
        "品番（海外)CD",
        "部品名称１",
        "部品名称2",
        "海外取引先",
        "品種CD",
        "品種名",
        "部品区分名",
        "作成日付",
      ];
      var values = [
        "code",
        "supplierCode",
        "name",
        "name2",
        "partnerName",
        "productCode",
        "productName",
        "type",
        "createDate",
      ];
      if (this.selected.length > 0) {
        this.$exportTable(this.selected, values, headers, "品番");
      } else {
        this.$http
          .get("/skus", {
            params: {
              ...this.query,
              ...this.$pageable(),
              size: 99999,
              page: 0,
            },
          })
          .then((res) => {
            this.$exportTable(res.data.content, values, headers, "品番");
          })
          .catch(() => {
            this.$message("", "download error");
            this.loading = false;
          });
      }
    },
    validDate() {
      if (
        this.query.createDateFrom != null &&
        this.query.createDateTo != null &&
        this.$daysBetween(this.query.createDateFrom, this.query.createDateTo) >
          31
      ) {
        this.query.createDateFrom = null;
        this.query.createDateTo = null;
        return false;
      }
      return true;
    },
    validCreateDateTo() {
      if (
        this.query.createDateFrom != null &&
        this.query.createDateTo != null &&
        this.$daysBetween(this.query.createDateFrom, this.query.createDateTo) <
          32
      ) {
        return false;
      }
      return true;
    },
    remove() {
      this.$confirm({ content: this.$t("app.messages.removeConfirm") }).then(
        () => {
          Promise.all(
            this.selected.map((i) => {
              return this.$http.delete(`/skus?code=${i.code}`);
            })
          ).then(() => {
            this.selected = [];
            this.load();
          });
        }
      );
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: "meta.createAt,desc",
        },
      };
    },
    search() {
      this.pagination.page = 1;
      this.load();
    },
    load() {
      this.autoload = true;
      // this.$storeParams();
      this.loading = true;
      this.$http
        .get("/skus", this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;
          this.loading = false;
          this.selected = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },

    create() {
      this.$router.push({
        path: "M0161/new",
      });
    },
    edit() {
      this.$router.push({
        path: "M0161/edit",
        query: { id: this.selected[0].code },
      });
    },
    skuMatchProduct(data) {
      console.log(data);
      var skuProductList = [];
      for (var i = 1; i < data.length; i++) {
        skuProductList.push({
          skuCode: String(data[i][0]),
          productCode: String(data[i][1]),
        });
      }
      this.$http
        .put("/skus/match", skuProductList)
        .then(() => {
          this.$message("", "SUCCESS");
        })
        .catch((err) => {
          this.$message("", "品種アップロードが失敗しました。");
        });
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
  mounted() {
    this.$loadParams();
    var today = new Date();
    var fromDate = new Date();
    fromDate.setDate(today.getDate() - 31);
    this.query.createDateFrom = fromDate.format("yyyy-MM-dd");
    this.query.createDateTo = today.format("yyyy-MM-dd");
  },
};
</script>
